import PropTypes from 'prop-types';
import { getTranslation } from '../../../utils/index.js';
import './consentement-recontact.scss';

const PARAGRAPHS = ['p1', 'p2', 'p3', 'p4', 'p5'];

const MANDANTS = {
    aprilMoto: { mandant: 'APRIL&nbsp;Moto', dpoEmail: 'dpo@april-moto.com' },
    amGestion: { mandant: 'AMGestion', dpoEmail: 'dpo@amgestionassurance.com' },
};

/**
 * Mentions légales du consentement au rappel téléphonique (ADM Value Assurance).
 * Utilisé sous le choix J'accepte / Je refuse (formulaires) et en bas de la popin "être rappelé".
 * @param isAmGestion  wording AMGestion (formulaire courtier) au lieu d'APRIL Moto
 * @param compact      police réduite (11px) pour la popin
 */
export const ConsentementRecontact = ({ className, isAmGestion = false, compact = false }) => {
    const variables = isAmGestion ? MANDANTS.amGestion : MANDANTS.aprilMoto;

    return (
        <div className={`consentement-recontact text-start ${compact ? 'consentement-recontact--compact' : ''} ${className ?? ''}`}>
            {PARAGRAPHS.map((key) => (
                <small
                    key={key}
                    className={'d-block mb-2'}
                    dangerouslySetInnerHTML={{ __html: getTranslation(`coordonnees.phone.acceptRecontact.legal.${key}`, variables) }}
                />
            ))}
        </div>
    );
};

ConsentementRecontact.propTypes = {
    className: PropTypes.string,
    isAmGestion: PropTypes.bool,
    compact: PropTypes.bool,
};
